import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { FhApplicationSetupService } from '@fh-client-interaction-frontends/fh-setup-service';

@Pipe({
  name: 'dynamicCurrency',
  pure: false
})
export class DynamicCurrencyPipe implements PipeTransform {
  private value: string | null = null;

  constructor(
    private currencyPipe: CurrencyPipe,
    private fhApplicationSetupService: FhApplicationSetupService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.fhApplicationSetupService.setup$.subscribe(() => {
      this.changeDetectorRef.markForCheck();
    });
  }

  transform(value: number | string, currencyCodeOverride?: string, displayOverride?: string, digitsInfoOverride?: string): string | null {
    const setup = this.fhApplicationSetupService.getCurrentSetup();
    if (!setup) return null;

    const locale = setup.locale || 'pt-PT';
    const currency = currencyCodeOverride || setup.currencyCode || 'EUR';

    return this.currencyPipe.transform(value, currency, displayOverride, digitsInfoOverride, locale);
  }
}
